import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js';
import { setupModel } from './setupModel.js';
// import { toConvert } from './jsonToGltf.js';
import Hammer from 'hammerjs';

async function loadModel(dom, options) {
  const loader = new GLTFLoader();

  // const glTFObj = await toConvert(options);
  // const heroData = await loader.parseAsync(glTFObj, options.path);  
  const heroData = await loader.loadAsync('http://127.0.0.1:5500/Aleta2/Aleta2.gltf');
  console.log('Squaaawk!', heroData);

  const { model, mixer } = setupModel(heroData);
  model.position.set(0, -1.01, 0);

  // 开启阴影
  model.traverse(function(object) {
    if(object.isObject3D) {
      object.castShadow = true;
      object.receiveShadow = true;
    }
  });


  // 模型旋转
  let cx = 0;
  let cx_temp = 0;
  let targetRotation = 0;
  
  let mc = new Hammer.Manager(dom);
  let Pan = new Hammer.Pan({ direction: Hammer.DIRECTION_HORIZONTAL });
  mc.add(Pan);
  mc.on('panstart', (e) => {
    // 初始化位置
    cx = e.center.x;
    cx_temp = cx;
  });
  mc.on('pan', (e) => {
    cx = e.center.x;
    let move = cx - cx_temp;
    targetRotation = targetRotation + move * 0.005;
    cx_temp = cx;
  });


  // 模型渲染
  model.tick = (delta) => {
    mixer.update(delta);
    model.rotation.y += (targetRotation - model.rotation.y) * 0.06;
  };

  return model;
}

export { loadModel };
